import { Domains } from 'monitoring/constants/domains'
import { sendError } from 'monitoring/sendError/server/sendError'
import {
	COLOR_SEARCH_PARAM,
	DEFAULT_LOOK_ID,
	LOOK_SEARCH_PARAM,
} from 'product/constants/constants'
import { getFromSessionStorage } from 'utils/webStorage/sessionStorage'

import { SELECTED_SIZE_ID_KEY } from '../../contexts/SizesProvider/SizesProvider'
import type { Color, FullProduct, Look, Size } from '../../types/FullProduct'

export type GetSelectedInfoProps = {
	colors: FullProduct['colors']
	searchParams: Record<string, string>
}

export function getSelectedColor({
	colors,
	searchParams,
}: GetSelectedInfoProps): Color {
	const selectedColor =
		colors.find((color) => color.id === searchParams[COLOR_SEARCH_PARAM]) ||
		colors.find((color) => !color.relatedProductId)

	if (!selectedColor) {
		throw sendError({
			domain: Domains.PDP,
			message: '[GetSelectedColor] Failed to get the default selected color',
		})
	}

	return selectedColor
}

export function getSelectedLook(params: GetSelectedInfoProps): Look {
	const selectedColor = getSelectedColor(params)

	return (
		selectedColor.looks[params.searchParams[LOOK_SEARCH_PARAM]] ||
		selectedColor.looks[DEFAULT_LOOK_ID]
	)
}

export function getSelectedSize(
	params: GetSelectedInfoProps
): Size | undefined {
	const color = getSelectedColor(params)

	const isUniqueSize = color.sizes.length === 1
	const uniqueSize = color.sizes[0]

	if (isUniqueSize) {
		return uniqueSize
	}

	return undefined
}

export function getStoredSelectedSize(
	params: GetSelectedInfoProps
): Size | undefined {
	const color = getSelectedColor(params)
	const isUniqueSize = color.sizes.length === 1
	const uniqueSize = color.sizes[0]

	if (isUniqueSize) {
		return uniqueSize
	}

	const sameSelectedSizeId = getFromSessionStorage<string>(SELECTED_SIZE_ID_KEY)

	if (sameSelectedSizeId) {
		const sameSelectedSize = color.sizes.find(
			(size) => size.id === sameSelectedSizeId && size.available
		)

		if (sameSelectedSize) {
			return sameSelectedSize
		}
	}

	return undefined
}
